import styled from '@emotion/styled';
import { Modal as BaseModal, ModalBody as BaseModalBody } from '@lightspeed/flame/Modal';
import { Heading2 as BaseHeading2, Heading3 as BaseHeading3 } from '@lightspeed/flame/Text';

export const Heading2 = styled(BaseHeading2)`
  font-size: 24px;
`;

export const Heading3 = styled(BaseHeading3)`
  font-size: 20px;
`;

export const Container = styled.div`
  background: #f5f4f2;
  position: relative;

  > div {
    padding-left: 65px;
    padding-right: 65px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  font-size: 24px;
  line-height: 1;
  color: #666;
  width: 32px;
  height: 32px;
  z-index: 1001;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #000;
  }

  &:focus {
    outline: 2px solid #0070f3;
    outline-offset: 2px;
  }
`;

export const AlertContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 32px 65px 0 65px !important;

  && p {
    line-height: normal;
  }
`;

export const Link = styled.a`
  font-weight: bold;
  color: #2e61de;
`;

export const Modal = styled(BaseModal)`
  max-width: 1000px;
  overflow: hidden;
`;

export const ModalBody = styled(BaseModalBody)`
  padding: 0;
  overflow-y: scroll;
`;
